import React from 'react';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon, SparklesIcon } from 'lucide-react';
import { ChakraOrnament } from './ChakraOrnament';
import { EbookCarousel } from './EbookCarousel';
import { Mandala } from './HealingIcons';
import { Pricing } from './Pricing';
import { Section } from './Shared';
type Bonus = {
  number: string;
  title: string;
  description: string;
  price: string;
};
const bonuses: Bonus[] = [{
  number: '01',
  title: 'Diario del Terapeuta Reiki™',
  description: 'Tu espacio sagrado de reflexión, aprendizaje y evolución profesional.',
  price: '$12.000'
}, {
  number: '02',
  title: 'Fichas Profesionales del Paciente',
  description: 'El registro clínico energético que transforma cada sesión en un proceso terapéutico real.',
  price: '$12.000'
}, {
  number: '03',
  title: 'Checklist de Apertura y Cierre',
  description: 'Rituales operativos para que ningún detalle profesional quede librado al azar.',
  price: '$10.000'
}, {
  number: '04',
  title: 'Cuaderno de Seguimiento',
  description: 'La herramienta que convierte sesiones aisladas en procesos terapéuticos sostenidos.',
  price: '$12.000'
}, {
  number: '05',
  title: 'Protocolos Rápidos de Consulta',
  description: 'Tu guía de referencia inmediata antes de cada sesión, en una sola mirada.',
  price: '$10.000'
}, {
  number: '06',
  title: 'Kit de Plantillas Imprimibles',
  description: 'Documentos profesionales que formalizan la consulta desde el primer contacto.',
  price: '$10.000'
}];
const modules = [['Mentalidad y Sistema', 'La diferencia entre practicar y ejercer'], ['Preparación y Espacio', 'El Ritual de los 15 Minutos™ y tu espacio terapéutico'], ['Arquitectura de la Sesión', 'El Reloj Maestro™, chakras y cierre profesional'], ['Registro y Seguimiento', 'Documentación, continuidad y organización']];
export function PackContents() {
  return <Section id="method" className="relative" data-id="element-190" data-mp="2ybcamgy3ctje">
      <Mandala className="absolute -left-16 top-16 -z-10 h-56 w-56 opacity-10" color="#76557C" data-id="element-191" data-mp="338m6offzk3g7" />
      <ChakraOrnament className="absolute right-8 top-20 -z-10 hidden h-44 opacity-35 xl:block" data-id="element-192" data-mp="136cwort1w0x9" />
      <div className="mx-auto max-w-5xl text-center" data-id="element-193" data-mp="y7t8sluwcf29">
        <span className="inline-flex items-center gap-1.5 rounded-full border border-brand-gold/55 bg-brand-paper px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-brand-purple shadow-sm" data-id="element-194" data-mp="y94cyms97otw">
          <BookOpenIcon className="h-3.5 w-3.5 text-brand-goldDark" aria-hidden="true" data-id="element-195" data-mp="184edt76x1q63" />
          Mirá el pack por dentro
        </span>
        <h2 className="mt-3 font-display text-[30px] font-bold leading-[0.9] text-brand-ink sm:text-4xl md:text-5xl" data-id="element-196" data-mp="1hvskq0175s99">
          Sin improvisación, sin incertidumbre:{' '}
          <span className="relative z-0 inline-block px-1.5 text-brand-purpleDark before:absolute before:inset-x-0 before:bottom-[0.06em] before:-z-10 before:h-[0.42em] before:-rotate-1 before:rounded-sm before:bg-brand-goldLight/90" data-id="element-197" data-mp="1vt7d9dmqyg5g">
            una consulta profesional
          </span>{' '}
          al alcance de tus manos.
        </h2>
      </div>

      <div className="mx-auto mt-7 grid max-w-5xl items-center gap-8 rounded-3xl border border-brand-purple/20 bg-brand-paper/85 p-5 shadow-[0_14px_40px_rgba(76,50,79,0.08)] md:grid-cols-[0.8fr_1.2fr] md:p-8" data-id="element-198" data-mp="2859gv0t3i4sc">
        <EbookCarousel data-id="element-199" data-mp="1yeoi9ddf909f" />
        <div className="flex flex-col justify-center" data-id="element-200" data-mp="1yfg6g34ovvpo">
          <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-brand-purple" data-id="element-201" data-mp="23e17g4rrmjf6">Tomo principal</span>
          <h3 className="mt-1 font-serif text-3xl font-bold leading-none text-brand-ink" data-id="element-202" data-mp="1pe8juibjcjbf">EL SISTEMA OPERATIVO DEL TERAPEUTA REIKI™</h3>
          <p className="mt-3 max-w-lg font-serif text-lg leading-snug text-brand-text" data-id="element-203" data-mp="1uc1p9950l9an">Tu manual de gestión y profesionalización de consulta.</p>
          <div className="mt-5 grid grid-cols-3 divide-x divide-brand-gold/35 rounded-2xl border border-brand-gold/35 bg-brand-surfaceLight/45 px-2 py-3 text-center" data-id="element-204" data-mp="1kf5e0vnqe92e">
            <Metric value="50" label="páginas" data-id="element-205" data-mp="3etzl6lxw1tmq" />
            <Metric value="26" label="capítulos" data-id="element-206" data-mp="3esoikpg6irx7" />
            <Metric value="4" label="módulos" data-id="element-207" data-mp="1erq9mtvb1j1o" />
          </div>
          <ul className="mt-5 space-y-3 text-sm leading-snug text-brand-muted" data-id="element-208" data-mp="1er6tnip7t4qa">
            {modules.map(([title, description]) => <li key={title} className="flex gap-2.5" data-id="element-209" data-mp="15r1ufvu6dcn7">
                <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-brand-purple" aria-hidden="true" data-id="element-210" data-mp="15ph0a7brvvpv" />
                <span data-id="element-211" data-mp="10rpb3l2iinpd"><strong className="font-semibold text-brand-forest" data-id="element-212" data-mp="10rp779ze63k3">{title}</strong> <span data-id="element-213" data-mp="vtw2ymhnfjmg">({description})</span></span>
              </li>)}
          </ul>
          <p className="mt-5 text-sm leading-relaxed text-brand-muted" data-id="element-214" data-mp="r12zs31twjch">Protocolo, método y presencia profesional en una consulta rápida.</p>
        </div>
      </div>

      <div className="mt-14 text-center" data-id="element-215" data-mp="i1pp571yxoq6">
        <h3 className="flex items-center justify-center gap-2 font-serif text-2xl font-bold text-brand-ink" data-id="element-216" data-mp="i2qzf9b5u76u">
          <GiftIcon className="h-5 w-5 text-brand-goldDark" aria-hidden="true" data-id="element-217" data-mp="d1v0zb9kvd8t" />
          6 BONOS ESTRATÉGICOS — <span className="text-brand-greenDark" data-id="element-218" data-mp="841tmewjgd6y">GRATIS</span>
        </h3>
      </div>
      <div className="mx-auto mt-7 grid max-w-6xl grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-219" data-mp="3u3xsfn2q73yk">
        {bonuses.map(bonus => <BonusCard key={bonus.number} bonus={bonus} data-id="element-220" data-mp="30iwbz7zds56" />)}
      </div>
      <div className="mt-7 text-center" data-id="element-221" data-mp="7yu5e7qgbymc">
        <span className="inline-block rounded-full border border-brand-gold/50 bg-brand-paper px-5 py-3 text-sm font-medium text-brand-text" data-id="element-222" data-mp="7vohgvtk72s7">
          Valor total bonos <span className="text-brand-muted line-through" data-id="element-223" data-mp="3bfkdqt9ianr7">$66.000</span>{' '}
          <strong className="text-brand-forest" data-id="element-224" data-mp="3gcja7ign76sk">→ GRATIS con tu MEGA PACK REIKI™</strong>
        </span>
      </div>
    </Section>;
}
export function MethodOverview() {
  return <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-225" data-mp="3q2vsf40zinvj">
      <Pricing data-id="element-226" data-mp="3q58jc6oq08kq" />
    </div>;
}
function Metric({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="px-2" data-id="element-227" data-mp="2xmutat9mlqw7">
      <strong className="block font-serif text-xl leading-none text-brand-purple" data-id="element-228" data-mp="2xmbcxgzmjaka">{value}</strong>
      <span className="mt-1 block text-[9px] font-bold uppercase tracking-[0.12em] text-brand-muted" data-id="element-229" data-mp="2pln8lavm3yml">{label}</span>
    </div>;
}
function BonusCard({
  bonus
}: {
  bonus: Bonus;
}) {
  return <article className="relative overflow-hidden rounded-2xl border border-brand-purple/20 bg-brand-paper p-5 shadow-[0_8px_20px_rgba(76,50,79,0.06)]" data-id="element-230" data-mp="2zchs47hh4k4c">
      <div className="absolute right-3 top-2 font-display text-6xl font-bold text-brand-purple/[0.07]" aria-hidden="true" data-id="element-231" data-mp="2udna37rbyzla">{bonus.number}</div>
      <div className="relative" data-id="element-232" data-mp="21og5br1a9drl">
        <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-brand-purple/10 text-xs font-bold text-brand-purple" data-id="element-233" data-mp="21phpcl0a1alg">{bonus.number}</span>
        <h4 className="mt-3 font-serif text-lg font-bold leading-tight text-brand-ink" data-id="element-234" data-mp="2bmnfnr12gxkm">{bonus.title}</h4>
        <p className="mt-2 text-sm leading-relaxed text-brand-muted" data-id="element-235" data-mp="3s04689obv75g">{bonus.description}</p>
        <p className="mt-4 text-xs text-brand-muted" data-id="element-236" data-mp="3n1sv7vmaqqln"><span className="line-through" data-id="element-237" data-mp="3n1116p8cl0xh">{bonus.price}</span> <strong className="text-brand-greenDark" data-id="element-238" data-mp="3ulbmsq9lvs5u">→ GRATIS</strong></p>
      </div>
    </article>;
}